module.exports = __webpack_public_path__ + "media/images/common/project_select_btn-4b177e2a465d3a5cc348b61f4fac1f93.png";